import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/software/$id/_$id/settings/integration/')({});